/**
 * Project Catalog memory (migration 0088) is opt-in until schema is deployed.
 * Set PROJECT_CATALOG_MEMORY_ENABLED=true (server) or VITE_PROJECT_CATALOG_MEMORY_ENABLED=true (client).
 */
export function parseProjectCatalogMemoryEnabled(raw: string | undefined | null): boolean {
  const v = raw?.trim().toLowerCase();
  return v === "true" || v === "1" || v === "yes";
}

export const PROJECT_CATALOG_SEED_FAILURE_TOAST =
  "Project Catalog memory could not be updated, but your proposal setup is ready.";
